import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { VipGrabber } from './VipSidebar';

// Lazy load view components
const VipAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorVipAdd" */ './VipSidebar'), 'VipAdd');

const VipEdit = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorVipEdit" */ './admin/VipEdit'), 'VipEdit');

const VipGuest = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorVipGuest" */ './guest/VipGuest'), 'VipGuest');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const VipConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/VIPCustomComponent.json',
  componentType: 'Vip',
  adminSidebarComponent: {
    addComponentView: VipAdd,
    dragComponentView: VipGrabber,
    editComponentView: VipEdit,
    createComponentView: VipEdit,
  },
  guestSiteComponent: VipGuest,
};
